/* oxlint-disable no-console */

export default function logDevServiceWorkerMessage(
  message: string,
  {errors}: {errors: Array<Error> | null} = {errors: null}
): void {
  const prefixedMessage = `[dev-service-worker] ${message}`;
  if (errors) {
    console.log(prefixedMessage, ...errors);
  } else {
    console.log(prefixedMessage);
  }
}
